import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import { UserAccountModel } from '../utils/types';

export interface UserFigureProps {
  userAccount: UserAccountModel;
}

export function UserFigure({ userAccount }: UserFigureProps) {
  return (
    <Wrapper className={Typography.BODY_14_REGULAR}>
      <Info>
        <span>내 신체정보</span>
        {userAccount.body.height}cm
      </Info>
      <Info>{userAccount.body.weight}kg</Info>
      {userAccount.body.sizeText && <Info>{userAccount.body.sizeText}</Info>}
    </Wrapper>
  );
}

const Wrapper = styled.ul`
  padding: 0 24px 16px;
  color: ${vars.v3Color.gray400};
  display: flex;
`;

const Info = styled.li`
  span {
    margin-right: 6px;
  }
  &::after {
    display: inline-block;
    content: '';
    width: 1px;
    height: 10px;
    background-color: ${vars.v3Color.gray200};
    margin: 0 5px;
  }
  &:last-of-type::after {
    display: none;
  }
`;
